import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
  FilterDropdownPaper,
  FilterSearchHeader,
  FilterSearchInput,
  FilterScrollContainer,
} from './FilterDropdown.styles';

export const FilterSearchContext = React.createContext(null);

export const currentFilterKeyRef = { current: null };
export const listboxRef = { current: null };
export const scrollContainerRef = { current: null };

const PaperWithSearch = React.forwardRef(({ children, ...paperProps }, ref) => {
  const inputRef = React.useRef(null);
  const context = React.useContext(FilterSearchContext);
  const filterKey = currentFilterKeyRef.current;
  const value = (filterKey && context?.searchTerms?.[filterKey]) || '';

  React.useEffect(() => {
    const frame = requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  const handleSearchChange = (e) => {
    if (filterKey && context?.setSearchTerms) {
      context.setSearchTerms((prev) => ({ ...prev, [filterKey]: e.target.value }));
    }
  };

  return (
    <FilterDropdownPaper ref={ref} {...paperProps}>
      <FilterSearchHeader>
        <FilterSearchInput
          inputRef={inputRef}
          placeholder="Search..."
          value={value}
          onChange={handleSearchChange}
          onMouseDown={(e) => e.stopPropagation()}
          inputProps={{ 'aria-label': 'Search options' }}
        />
        <IconButton
          size="large"
          onClick={(e) => {
            e.stopPropagation();
            context?.closeMenu?.();
          }}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </FilterSearchHeader>
      <FilterScrollContainer
        ref={(el) => {
          scrollContainerRef.current = el;
        }}
      >
        {children}
      </FilterScrollContainer>
    </FilterDropdownPaper>
  );
});

PaperWithSearch.displayName = 'PaperWithSearch';

export { PaperWithSearch };
